import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { roleColor } from '../../../../lib/reportRoleColors';
import { EditorialRecommendations } from '../../report/editorial';

/**
 * Total water cost — the master schema doesn't carry a dedicated cost field,
 * so we render the recommendations list (which typically includes cost-bearing
 * actions like ZLD, reuse, etc.) and rely on the AI's natural-language summary
 * surfacing cost considerations there.
 *
 * W1a editorial port: the data shape is a FLAT string list (no key/value
 * pairs), so neither EditorialDefinitionList nor EditorialDatasheet fits —
 * EditorialRecommendations (the numbered-actions primitive) is the closest
 * fit and replaces the ad-hoc accent-dot bullet list. GAP: a structured cost
 * breakdown ($/kGal, annual opex) is not generated — do not fabricate one.
 */
export const TotalWaterCostSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const recs = report.waterAnalysis?.recommendations ?? [];
  return (
    <SectionShell label={label} hasData={recs.length > 0}>
      <p className="text-xs italic" style={{ color: roleColor(theme, 'muted') }}>
        Cost-bearing actions surfaced from the water analysis recommendations:
      </p>
      <EditorialRecommendations
        theme={theme}
        heading="Cost-bearing actions"
        items={recs}
      />
    </SectionShell>
  );
};
